import React from "react";
import LegalShell from "@/components/LegalShell";

export default function Refund() {
  return (
    <LegalShell title="Refund Policy">
      <div className="space-y-6 text-slate-700 leading-relaxed text-base" data-testid="refund-content">
        <p>
          Because the "Back Pain Relief Guide PDF" is a digital product delivered instantly
          after payment, all sales are considered <strong>final</strong>.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>1. Non-Refundable</h2>
        <p>
          Once the PDF has been delivered to your WhatsApp or email, the purchase is
          non-refundable.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>2. Exceptions</h2>
        <p>
          We will consider a refund only if:
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>You were charged but did not receive the PDF within 24 hours and we are unable to deliver it.</li>
          <li>You were accidentally charged twice for the same order.</li>
        </ul>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>3. How to Request</h2>
        <p>
          Email <a href="mailto:sudeepm8618@gmail.com" className="text-emerald-600 font-semibold">sudeepm8618@gmail.com</a> within
          7 days of purchase with your payment reference. Approved refunds are processed in
          5–10 business days to the original payment method via Razorpay.
        </p>

        <h2 className="text-xl font-bold text-[#1E3A8A]" style={{ fontFamily: "Outfit" }}>4. Need Help First?</h2>
        <p>
          If you're having trouble with the exercises or any part of the guide, message us on
          WhatsApp before requesting a refund — we're happy to help.
        </p>
      </div>
    </LegalShell>
  );
}
